/* Homepage Encensoria — Reveal animations + scroll-snap dots
   Léger, vanilla, IntersectionObserver. */
(function () {
  'use strict';

  // 1) Reveal animations (fade-up séquencé)
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.hp-reveal').forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    document.querySelectorAll('.hp-reveal').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  // 2bis) Flèches scroll mobile factorisées (.hp-scroll-arrow + data-hp-arrow-target)
  document.querySelectorAll('.hp-scroll-arrow').forEach(function (btn) {
    var trackId = btn.getAttribute('data-hp-arrow-target');
    var track = document.getElementById(trackId);
    if (!track) return;
    var dir = btn.classList.contains('hp-scroll-arrow--right') ? 1 : -1;
    btn.addEventListener('click', function () {
      track.scrollBy({ left: dir * track.offsetWidth * 0.7, behavior: 'smooth' });
    });
  });
  document.querySelectorAll('[data-hp-scroll-track]').forEach(function (track) {
    var leftBtn = document.querySelector('.hp-scroll-arrow--left[data-hp-arrow-target="' + track.id + '"]');
    var rightBtn = document.querySelector('.hp-scroll-arrow--right[data-hp-arrow-target="' + track.id + '"]');
    if (!leftBtn && !rightBtn) return;
    function update() {
      var atStart = track.scrollLeft <= 10;
      var atEnd = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 10;
      if (leftBtn) leftBtn.classList.toggle('is-hidden', atStart);
      if (rightBtn) rightBtn.classList.toggle('is-hidden', atEnd);
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  // 2) Scroll-snap dots (mobile uniquement)
  document.querySelectorAll('[data-hp-snap]').forEach(function (snap) {
    var dotsId = snap.getAttribute('data-hp-snap');
    var dots = document.getElementById(dotsId);
    if (!dots) return;
    var items = snap.querySelectorAll('.hp-snap__item');
    if (!items.length) return;

    var dotEls = dots.querySelectorAll('.hp-snap-dots__dot');
    if (dotEls.length !== items.length) return;

    var itemObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var idx = Array.prototype.indexOf.call(items, entry.target);
        dotEls.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      });
    }, { root: snap, threshold: 0.6 });

    items.forEach(function (item) { itemObserver.observe(item); });
  });
})();
